import "./index.css";
import { Users, Layers, Mail, Aperture, Trello, Award, Edit, Edit3, BookOpen, Wind, Anchor } from "react-feather";
import Users_Profile from "../Users/profiles";
import Users_Memberships from "../Users/memberships";
import Mailboxes from "../Mailboxes/index";
import Role_Mailboxes from "../Roles/mailboxes";
import Departments from "../Departments";
import Role_Global from "../Roles/global";
import Mailboxes_Members from "../Mailboxes/memberships";
import { createContext, useEffect, useState } from "react";
import { getTenantAuth, getTenants, parseJwt } from "../Auth/TokenManager";
import { iTenant, selectedTenant } from "../Auth/types";
import { tenantContext } from "./contexts";
import { useNavigate } from "react-router";
import Templates from "../EmsSetup/templates";
import Categories from "../EmsSetup/categories";
import MTemplates from "../Mailboxes/templates";
import { GetDepartments } from "../Logic/department";
import { GenericList, GetGenericLists } from "../Logic/TenantAPI";
import { GetMailboxes } from "../Mailboxes/TenantAPI";
import Loading from "../Generic/loading";
import { GetMailboxEditorConfig, iMailboxConfig } from "../Logic/config";

enum NavSections {
    Users = "users",
    Mailboxes = "mailboxes",
    Roles = "roles",
    Departments = "departments",
    Setup = "setup",
}

enum NavItems {
    Users_Profile = " edit user profiles",
    Users_Memberships = " user memberships",
    Mailbox_Memberships = " mailbox members",
    Mailbox_Mailboxes = " mailbox boxes",
    Mailbox_Templates = " mailbox templates",
    Roles_Global = " global roles",
    Roles_Mailboxes = "mailbox roles",
    Departments_profiles = "departments profiles",
    Setup_templates = "setup templates",
    Setup_skins = "setup skins",
    Setup_links = "setup links",
    Setup_categories = "setup categories",
}

function Main() {
    const [showSection, setShowSection] = useState<NavSections>(NavSections.Mailboxes);
    const [showNavItem, setShowNavItem] = useState<NavItems>(NavItems.Mailbox_Mailboxes);
    const [allTenants, setAllTenants] = useState<{ key: string; name: string }[]>([]);
    const [selectedTenant, setSelectedTenant] = useState<selectedTenant | undefined>(undefined);
    const [departments, setDepartments] = useState<GenericList[]>([]);
    const [mailboxes, setMailboxes] = useState<GenericList[]>([]);
    const [actions, setActions] = useState<GenericList[]>([]);
    const [mailboxEditorConfigurations, setMailboxEditorConfigurations] = useState<
        { id: number; config: iMailboxConfig }[]
    >([]);
    const [isLoading, setIsLoading] = useState<Boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            const tennants = await getTenants();
            if (!tennants.isAdmin) {
                navigate("/noAccess");
            }
            setAllTenants(tennants.tenants);
            checkTenantToken();
        })();
    }, []);

    useEffect(() => {
        (async () => {
            if (mailboxes.length > 0 && selectedTenant) {
                let mailboxEditorConfigs: { id: number; config: iMailboxConfig }[] = [];
                for (var i = 0; i < mailboxes.length; i++) {
                    let editorConfigResult = await GetMailboxEditorConfig(
                        selectedTenant.token,
                        `Config/Editor/${mailboxes[i].id}`,
                    );
                    if (editorConfigResult.isOk) {
                        mailboxEditorConfigs.push({ id: mailboxes[i].id, config: editorConfigResult.data! });
                    }

                    if (i == mailboxes.length - 1) {
                        setMailboxEditorConfigurations(mailboxEditorConfigs);
                        setIsLoading(false);
                    }
                }
            } else {
                setIsLoading(false);
            }
        })();
    }, [mailboxes]);

    const selectTenantHandler = async (e: React.FormEvent<HTMLSelectElement>) => {
        let event = e.currentTarget; // i have to do this . see this link for why  https://stackoverflow.com/questions/66085763/why-currenttarget-value-is-null
        const result = await getTenantAuth(event.value);
        const departments_results = GetGenericLists("Departments", result.token);
        const mailboxes_results = GetGenericLists("Mailboxes", result.token);
        const actions_results = GetGenericLists("Config/Actions", result.token);

        setIsLoading(true);
        Promise.all([departments_results, mailboxes_results, actions_results]).then(results => {
            if (results[0].isOk) {
                setDepartments(results[0].data?.items!);
            }
            if (results[1].isOk) {
                setMailboxes(results[1].data?.items!);
            }
            if (results[2].isOk) {
                setActions(results[2].data?.items!);
            }

            setSelectedTenant({ ...result, name: event[event.selectedIndex].innerText, key: event.value });
            setIsLoading(true);
        });
    };

    const checkTenantToken = async () => {
        if (selectedTenant) {
            const idToken = parseJwt(selectedTenant.token);
            let expiredDate = new Date(idToken.exp * 1000);
            let currentDate = new Date();
            if (
                expiredDate < currentDate ||
                Math.floor((expiredDate.getTime() - new Date().getTime()) / 60) < 10 // means token is about to expire in 10 mins or less
            ) {
                const result = await getTenantAuth(selectedTenant.key);
                setSelectedTenant({ ...result, name: selectedTenant.name, key: selectedTenant.key });
            }
            setTimeout(
                function () {
                    checkTenantToken();
                },
                1000 * 60 * 7,
            );
        }
    };

    return (
        <>
            <tenantContext.Provider
                value={{
                    selectedTenant,
                    departments,
                    mailboxes,
                    actions,
                    setSelectedTenant,
                    setDepartments,
                    mailboxEditorConfigurations,
                }}
            >
                <div className="topBar">
                    <div>
                        <img
                            src={require("../img/ems-logo.png")}
                            style={{ width: "100px", float: "left" }}
                        />
                        <div style={{ margin: "3px 0px 0px 10px" }}>&nbsp; ver: {process.env.REACT_APP_VERSION}</div>
                    </div>
                    <div>
                        {" "}
                        Tenant &nbsp;
                        <select
                            style={{ width: "150px", fontSize: "9pt" }}
                            onChange={selectTenantHandler}
                        >
                            {selectedTenant == undefined && <option value={""}> Please Select </option>}

                            {allTenants.map(x => {
                                return (
                                    <option
                                        value={x.key}
                                        key={x.key}
                                    >
                                        {x.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                {allTenants.length == 0 && <Loading></Loading>}
                {allTenants.length > 0 && isLoading == true && <Loading></Loading>}
                {selectedTenant && (
                    <div className="mainContainer">
                        <div className="sideNavBar">
                            <div className={showSection == NavSections.Users ? "navSection-active" : "navSection"}>
                                <div
                                    className="navItem"
                                    onClick={() => {
                                        setShowSection(NavSections.Users);
                                        setShowNavItem(NavItems.Users_Profile);
                                    }}
                                >
                                    <div>
                                        {" "}
                                        <Users style={{ width: "18px", color: "green" }} />
                                    </div>
                                    <div> Users </div>
                                </div>
                                {showSection == NavSections.Users && (
                                    <>
                                        <div
                                            className={
                                                showNavItem == NavItems.Users_Profile
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Users_Profile);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <Mail style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Profiles </div>
                                        </div>
                                        <div
                                            className={
                                                showNavItem == NavItems.Users_Memberships
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Users_Memberships);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <Aperture style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Memberships </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className={showSection == NavSections.Mailboxes ? "navSection-active" : "navSection"}>
                                <div
                                    className="navItem"
                                    onClick={() => {
                                        setShowSection(NavSections.Mailboxes);
                                        setShowNavItem(NavItems.Mailbox_Memberships);
                                    }}
                                >
                                    <div>
                                        {" "}
                                        <Mail style={{ width: "18px", color: "blue" }} />
                                    </div>
                                    <div> Mailboxes </div>
                                </div>
                                {showSection == NavSections.Mailboxes && (
                                    <>
                                        <div
                                            className={
                                                showNavItem == NavItems.Mailbox_Mailboxes
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Mailbox_Mailboxes);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <Mail style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Mailboxes </div>
                                        </div>
                                        <div
                                            className={
                                                showNavItem == NavItems.Mailbox_Memberships
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Mailbox_Memberships);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <Aperture style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Memberships </div>
                                        </div>
                                        <div
                                            className={
                                                showNavItem == NavItems.Mailbox_Templates
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Mailbox_Templates);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <BookOpen style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Templates </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className={showSection == NavSections.Roles ? "navSection-active" : "navSection"}>
                                <div
                                    className="navItem"
                                    onClick={() => {
                                        setShowSection(NavSections.Roles);
                                        setShowNavItem(NavItems.Roles_Mailboxes);
                                    }}
                                >
                                    <div>
                                        {" "}
                                        <Award style={{ width: "18px", color: "Red" }} />
                                    </div>
                                    <div> Roles </div>
                                </div>
                                {showSection == NavSections.Roles && (
                                    <>
                                        <div
                                            className={
                                                showNavItem == NavItems.Roles_Mailboxes
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Roles_Mailboxes);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <Mail style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Mailboxes </div>
                                        </div>
                                        <div
                                            className={
                                                showNavItem == NavItems.Roles_Global
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Roles_Global);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <Aperture style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Global </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div
                                className={showSection == NavSections.Departments ? "navSection-active" : "navSection"}
                            >
                                <div
                                    className="navItem"
                                    onClick={() => {
                                        setShowSection(NavSections.Departments);
                                        setShowNavItem(NavItems.Departments_profiles);
                                    }}
                                >
                                    <div>
                                        {" "}
                                        <Trello style={{ width: "18px", color: "#059975" }} />
                                    </div>
                                    <div> Departments </div>
                                </div>
                                {showSection == NavSections.Departments && (
                                    <>
                                        <div
                                            className={
                                                showNavItem == NavItems.Departments_profiles
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Departments_profiles);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <Trello style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Departments </div>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className={showSection == NavSections.Setup ? "navSection-active" : "navSection"}>
                                <div
                                    className="navItem"
                                    onClick={() => {
                                        setShowSection(NavSections.Setup);
                                        setShowNavItem(NavItems.Setup_templates);
                                    }}
                                >
                                    <div>
                                        {" "}
                                        <Edit3 style={{ width: "18px", color: "#18A8D9" }} />
                                    </div>
                                    <div> EMS Setup </div>
                                </div>
                                {showSection == NavSections.Setup && (
                                    <>
                                        <div
                                            className={
                                                showNavItem == NavItems.Setup_templates
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Setup_templates);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <BookOpen style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Templates </div>
                                        </div>
                                        <div
                                            className={
                                                showNavItem == NavItems.Setup_skins
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Setup_skins);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <Wind style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Skins </div>
                                        </div>
                                        <div
                                            className={
                                                showNavItem == NavItems.Setup_links
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Setup_links);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <Anchor style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Links </div>
                                        </div>
                                        <div
                                            className={
                                                showNavItem == NavItems.Setup_categories
                                                    ? "navSubItem selected"
                                                    : "navSubItem"
                                            }
                                            onClick={() => {
                                                setShowNavItem(NavItems.Setup_categories);
                                            }}
                                        >
                                            <div>
                                                {" "}
                                                <Layers style={{ width: "14px", color: "grey" }} />
                                            </div>
                                            <div> Categories </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="bodyContainer">
                            {showNavItem == NavItems.Users_Profile && <Users_Profile></Users_Profile>}
                            {showNavItem == NavItems.Users_Memberships && <Users_Memberships></Users_Memberships>}
                            {showNavItem == NavItems.Mailbox_Memberships && <Mailboxes_Members></Mailboxes_Members>}
                            {showNavItem == NavItems.Setup_templates && <Templates></Templates>}
                            {showNavItem == NavItems.Mailbox_Templates && <MTemplates></MTemplates>}
                            {showSection == "mailboxes" && <Mailboxes></Mailboxes>}
                            {showNavItem == NavItems.Roles_Global && <Role_Global></Role_Global>}
                            {showNavItem == NavItems.Roles_Mailboxes && <Role_Mailboxes></Role_Mailboxes>}
                            {showNavItem == NavItems.Departments_profiles && <Departments></Departments>}
                            {showNavItem == NavItems.Setup_categories && <Categories></Categories>}
                        </div>
                    </div>
                )}
            </tenantContext.Provider>
        </>
    );
}

export default Main;
